import axios from 'axios';

import config, { API } from '../../config';

export function formatFilename(name, folderID) {
  return name.replace(`SFMediaSubmissions/${folderID}/`, '');
}

export function cleanPath(path) {
  if (path.startsWith('/')) {
    let updatedPath = path.replace('/', '');

    return updatedPath;
  } else return path;
}

export function exit(e) {
  e.preventDefault();
  e.returnValue = '';
}

export async function sendErrorReport(errorMsg, url = 'N/A', lineNumber = 'N/A') {
  console.log('[*] SendErrorReport: ', JSON.stringify(errorMsg), url, lineNumber);
  let reqData = {
    message: JSON.stringify(errorMsg),
    fileName: url,
    lineNumber: lineNumber,
    url: window.location.href,
  };
  try {
    const errorCallResponse = await axios.post(`${API}/v1/webjsxrror`, reqData);
    console.log('errorCallResponse: ', errorCallResponse);
  } catch (err) {
    console.log('[E] Error while error', err);
  }
}

export function addExitPopup() {
  window.addEventListener('beforeunload', exit);
  window.addEventListener('unload', exit);
}

export function removeExitPopup() {
  window.removeEventListener('beforeunload', exit);
  window.removeEventListener('unload', exit);
}
